import React, { useEffect, useRef, useState } from 'react';

interface AdSpaceProps {
  className?: string;
  // Legacy props kept so existing imports don't crash
  type?: string; 
  slot?: string;
  layoutKey?: string;
  format?: string;
}

const AdSpace: React.FC<AdSpaceProps> = ({ className, type }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isMobile, setIsMobile] = useState(false);

  // Check window size to determine which banner to show
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile(); // initial check
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Adsterra Banners: 320x50 for mobile, 728x90 for desktop
  const adId = isMobile ? 'e7adaf73e584fd31d8949ead37ee7637' : '1a1bd068521809328c1564f05dfed6ee';
  const width = isMobile ? 320 : 728;
  const height = isMobile ? 50 : 90;

  useEffect(() => {
    if (!containerRef.current) return;
    
    // Clear previous ad if any
    containerRef.current.innerHTML = '';
    
    if (type === 'in-article' || type === 'in-feed') {
      // Native Banner Logic
      containerRef.current.innerHTML = '<div id="container-0759ffd6a31baec182bf869634f1e46a"></div>';
      const script = document.createElement('script');
      script.async = true;
      script.setAttribute('data-cfasync', 'false');
      script.src = 'https://pl29014616.profitablecpmratenetwork.com/0759ffd6a31baec182bf869634f1e46a/invoke.js';
      containerRef.current.appendChild(script);
    } else {
      // Standard Banner Logic
      const conf = document.createElement('script');
      conf.type = 'text/javascript';
      conf.innerHTML = `
        atOptions = {
          'key' : '${adId}',
          'format' : 'iframe',
          'height' : ${height},
          'width' : ${width},
          'params' : {}
        };
      `;
      
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = `//www.highperformanceformat.com/${adId}/invoke.js`;
      
      containerRef.current.appendChild(conf);
      containerRef.current.appendChild(script);
    }
  }, [adId, width, height, type]);

  return (
    <div className={`flex flex-col items-center justify-center w-full my-8 ${className || ''}`}>
       <p className="text-[10px] text-gray-500 uppercase tracking-widest mb-1 select-none">Advertisement</p>
       <div ref={containerRef} style={{ width: (type === 'in-article' || type === 'in-feed') ? '100%' : width, overflow: 'hidden' }} />
    </div>
  );
};

export default AdSpace;
